import { render, staticRenderFns } from "./asociar-coordinador-f1.vue?vue&type=template&id=609d1036&"
import script from "./asociar-coordinador-f1.component.ts?vue&type=script&lang=ts&"
export * from "./asociar-coordinador-f1.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports